// extracted by mini-css-extract-plugin
export default {"fileBrowser":"ResourcesPage_fileBrowser__LHkbw"};